import { Store } from "./store";
import {Pagination,PaginationResponse} from '@/models/Pagination';
import { reactive, readonly, watch, ref } from 'vue';

export class PaginationStore extends Store {
    constructor(storeName) {
        super(storeName);
        this.storeName = storeName;
        this.isInitialized = ref(false);
        this.paginationParams = reactive(new Pagination({currentPage:0,elements:10}));    
        this.pagination = reactive(new PaginationResponse());
        this.updating=  ref(false); // updating params to align pagination's info
        this.loading=  ref(false); // loading params using call
    }

    // #2
    async initPagination(_pagination) {     
        if (this.isInitialized) {
            if(_pagination){
                this.updating= true
                this.paginationParams.currentPage=_pagination.currentPage?_pagination.currentPage:this.paginationParams.currentPage
                this.paginationParams.elements=_pagination.elements?_pagination.elements:this.paginationParams.elements
                this.updating= false
            }
            let paginationFromIndexedDB = localStorage.getItem(this.storeName);
            if (paginationFromIndexedDB) {
                console.log("paginationFromIndexedDB");
                this.updating=true
                Object.assign(this.pagination, JSON.parse(paginationFromIndexedDB));
                if (this.pagination.totalElements>0&&
                    Math.floor(this.pagination.totalElements / this.paginationParams.elements) <= this.pagination.currentPage)
                { this.pagination.currentPage = 0 }
                this.paginationParams.currentPage=this.pagination.currentPage
            }
            // Adding call to 
            this.state.call=ref(this.state.call?this.state.call:new Promise(()=>[]))
            watch(() => this.paginationParams, 
            async (val) => { 
                if(!this.updating){
                    console.log(val);
                this.state.data=await this.loadData(val,await this.getState().call); 
                }return}, 
                { deep: true });
            watch(() => this.pagination, 
            async (val) => { 
                console.log( val);
                localStorage.setItem(this.storeName, JSON.stringify(val))}, 
                { deep: true });
            this.isInitialized.value = true;
        }
    }
    
    getPagination() {
        return readonly(this.pagination);
    }

    setPagination({pages, currentPage,  elements, totalElements, filters}){
        this.updating=true;
        this.pagination.pages=pages||pages==0?pages:this.pagination.pages;
        this.pagination.currentPage= currentPage==null||currentPage==undefined?this.pagination.currentPage:currentPage;
        this.pagination.elements=  elements||elements==0?elements :this.pagination.elements;
        this.pagination.totalElements=totalElements|| totalElements==0?totalElements:this.pagination.totalElements;
        this.pagination.filters= filters?filters:this.pagination.filters;
        // this.pagination=new PaginationResponse(pages, currentPage,  elements, totalElements, filters)
    } 

    async nextPage(){
        const nextpage=(this.pagination.currentPage+1)<this.pagination.pages?(this.pagination.currentPage+1):this.pagination.currentPage
        this.toPage(nextpage)

    }
    async previousPage(){
        const prewpage=(this.pagination.currentPage-1)>=0?(this.pagination.currentPage-1):this.pagination.currentPage
        this.toPage(prewpage)
    }
    async toPage(page){
        this.updating=false;
        this.paginationParams.currentPage= page;
    }
    async elemetsPerPage(elNumb){
        this.updating=true;
        console.log("elNumb",elNumb)
        this.paginationParams.elements= elNumb;
        /* 
         changing element number there's maybe the chance that 
         the amount of page reduct to the point 
         that the current page become out of the bound 
         SOLUTION: calculate this possibility and anticipate it
         biside what pagination inf my return the call
         (if (Math.floor(elements / elNumb) < currentPage)  currentPage == 1)
        */
         if (this.pagination.totalElements>0&&Math.floor(this.pagination.totalElements / elNumb) <= this.paginationParams.currentPage)
         { this.paginationParams.currentPage = 0 }
        this.toPage(  this.paginationParams.currentPage)
    }
    async setsFilters(...filters){
        this.updating=false;
        this.paginationParams.filters= filters;
    }
    async setFilter(name,filter){
        this.updating=false;
        this.paginationParams.filters[name]= filter;
    }
    // currentPage cunt from 0 but pages is the actual number
        //fun must be an async function function

    async loadPage(page,funct){
        if(funct&&page<this.pagination.pages&&page>=0){
            const paginationParams ={...this.paginationParams}
        paginationParams.currentPage=page
       this.state.data=await this.loadData(paginationParams,funct)
    }
    }
    async loadData(paginationParams,funct){
        this.state.loading=true
       return  funct(paginationParams).then(result => {
                if (result && result.pagination && result.data) {
                    this.state.loading=false
                    console.log(result);                    
                    return Promise.resolve(result);
                } else {
                    this.state.loading=false
                    return  Promise.reject(new Error("Invalid structure of the returned object from funct."));
                }
            }).catch(error => {
                console.error("Error:", error);
                this.state.loading=false
                Promise.reject(error);
            }).then(({pagination, data})=>{
                console.log(pagination, data);                
                this.setPagination(pagination)
                this.state.loading=false
                return Promise.resolve(data);
            }).catch(error => {
                console.error("Error:", error);
                this.setPagination(new PaginationResponse())
                this.state.loading=false
                return Promise.resolve(this.state.data);
            })   
    }
    
    closeStore(){
        localStorage.removeItem(this.storeName)
        this.isInitialized.value=false
    }
    getIsInitialized() {
        return this.isInitialized;
    }
}
